export const validators = {
  email: function (value) {
    const _pattern = /^([0-9a-zA-Z]([-.\w+]*[0-9a-zA-Z+])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})$/
    return _pattern.test(value)
  },
  phone: function (value) {
    const _pattern = /(\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[670]|7|1)|0)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{0,3})$/
    return _pattern.test(value)
  }
}
